/** @jsx jsx */
import { memo, useMemo } from 'react';
import { jsx } from '@emotion/core';
import { dayNameGridStyle, dayNameCellStyle as getDayNameCellStyle } from '../styles/grid';
var WeekHeader = /*#__PURE__*/memo(function WeekHeader(_ref) {
  var daysShort = _ref.daysShort,
      mode = _ref.mode;
  var dayNameCellStyle = useMemo(function () {
    return getDayNameCellStyle(mode);
  }, [mode]);
  return jsx("div", {
    css: dayNameGridStyle
  }, daysShort.map(function (shortDay) {
    return jsx("span", {
      css: dayNameCellStyle,
      key: shortDay
    }, shortDay);
  }));
});
WeekHeader.displayName = 'WeekHeader';
export default WeekHeader;